import { flashError } from './flashMessage'

export const onFormError = (error, variables, context) => {
  if (error?.response?.status === 400) {
    return
  }
  flashError({
    title: 'Error inesperado',
    description: 'Lo sentimos pero ha ocurrido un error desconocido, por favor vuelva a intentar más tarde.'
  })
}

export const onDeleteError = (error, variables, context) => {
  if (error?.response?.status === 409) {
    flashError({ description: 'It is not possible to delete the entity.' })
    return
  }
  flashError({
    title: 'Error inesperado',
    description: 'Lo sentimos pero ha ocurrido un error desconocido, por favor vuelva a intentar más tarde.'
  })
}

export const onActionError = () => {
  flashError({
    title: 'Error inesperado',
    description: 'Lo sentimos pero ha ocurrido un error desconocido, por favor vuelva a intentar más tarde.'
  })
}
